export default "__VITE_ASSET__DV393ynY__"